// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PopupContentPreview_wrapper__3qdfT","bar":"PopupContentPreview_bar__2LUF-"};